export default __webpack_public_path__ + "assets/img/c1bd430d4132c42407dce1b996c40f66.svg";